import dayjs from 'App/helpers/dayjs'

export default function() {
  return dayjs.tz.guess()
}
